import { useCallback } from 'react';
import { useHistory } from 'hooks/generic/useHistory';
import { normalizePathname } from 'utils';
import { getInitialMountingPath } from 'utils/app/get-initial-mounting-path';

export const useOpenArtistView = () => {
  const { push } = useHistory();

  const handleOpenArtist = useCallback((artistUrlKey: string) => {
    const redirectPath = normalizePathname(
      `${getInitialMountingPath(true)}/artists/${artistUrlKey}`
    );
    return push(redirectPath);
  }, []);

  return { handleOpenArtist };
};
